export default __webpack_public_path__ + "static/medgas_manifold_w.4af0b80074f578d1abd320eff656d708.png";